<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
    <div class="content">
    <div class="content-title">
      <h2>
        プレミアムふきだしコメント
      </h2>
      <p>フォントや色をカスタマイズできます</p>
    </div>
    <div class="contents-block">
        <div class="line__left" v-bind:class="fontStyle" v-bind:style="[mainColor, subColor, svgBackground]">
            <div class="line__left-text">
                <div class="text">Hello🐟</div>
            </div>
            <div class="line__left-text">
                <div class="text">いい天気ですね</div>
            </div>
        </div>
        <div class="set">
        <h3>フォント選択</h3>
        <select class="select " v-model="fontstyle">
            <optgroup label="--ゴシック--">
            <option value="font1">Zen角ゴシックAntique</option>
            <option value="font4">DotGothic16</option>
            <option value="font7">M PLUS Rounded 1c</option>
            <option value="font6">キウイ丸</option>
            </optgroup>
            <optgroup label="--ポップ--">
            <option value="font2">はちまるポップ</option>
            <option value="font8">ロックンロールOne</option>
            </optgroup>
            <optgroup label="--明朝--">
            <option value="font12">さわらび明朝</option>
            <option value="font13">しっぽり明朝</option>
            </optgroup>
            <optgroup label="--デザイン--">
            <option value="font3">Stick</option>
            <option value="font5">解星デコール</option>
            <option value="font9">佑字【舞】</option>
            <option value="font10">油性マジック</option>
            </optgroup>
            <optgroup label="--Chinese--">
            <option value="font14">Noto Serif</option>
            </optgroup>
            <optgroup label="--English--">
            <option value="font15">Josefin Sans</option>
            </optgroup>
        </select>
        <div class="color-select">
          <div class="color-row">
            <h3>フォントカラー選択</h3>
            <div class="radio-main">
            <chrome-picker :value="colors" v-model="colors"></chrome-picker>
            </div>
          </div>
          <div class="color-row">
            <h3>背景カラー選択</h3>
            <div class="radio-main">
            <chrome-picker :value="colors3" v-model="colors3"></chrome-picker>
            </div>
          </div>
          <div class="color-row">
            <h3>サブカラー選択</h3>
            <div class="radio-main">
            <chrome-picker :value="colors2" v-model="colors2"></chrome-picker>
            </div>
          </div>
        </div>

        <h3>コピペ用CSS</h3>
        <div class="radio-main">
            <textarea id="target" readonly class="m-form-text" v-model="resultCSS" />
            <button @click="copy" class="copy-btn">コピー</button>
        </div>
        </div>
    </div>
    </div>
</div>
  </div>
</template>
<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"
import { Chrome } from "vue-color";
export default {
  name: "app",
  components: {
    secondHeader,
    sidebar,
    "chrome-picker": Chrome,
  },

  data() {
    return {
        fontstyle:'font1',
        colors: {
            hex: "#571512",
            hex8: '#571512',
            hsl: { h: 3, s: 79, l: 34, a: 1 },
            rgba: { r: 87, g: 21, b: 18, a: 1 },
            a: 1,
        },
        colors2: {
            hex: "#f0c8a4",
            hex8: '#f0c8a4',
            hsl: { h: 28, s: 32, l: 94, a: 1 },
            rgba: { r: 240, g: 200, b: 164, a: 1 },
            a: 1,
        },
        colors3: {
            hex: "#ffffff",
            hex8: '#ffffff',
            hsl: { h: 28, s: 0, l: 100, a: 1 },
            rgba: { r: 255, g: 255, b: 255, a: 1 },
            a: 1,
        },
        svgBackground: {
          "--bg-svg": '',
          "--bg-color": ''
        },
        importcss1:':root{--main-color:',
        importcss2: "!important;--sub-color:",
        importcss3: "!important;--bg-color:",
        importcss4: "!important;--bg-svg:",
        fontcss:'!important;\n--font: "Zen Kaku Gothic Antique", sans-serif!important;}',
    };
  },
  watch: {
    colors3: {
      handler() {
        this.updateSvgBackground();
      },
      deep: true
    },
    fontstyle:function(){
        this.setFontCss()
    },
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.importcss1 +
            this.colors.hex8 +
            this.importcss2 +
            this.colors2.hex8 +
            this.importcss3 +
            this.colors3.hex8 +
            this.importcss4 +
            this.svgBackground["--bg-svg"] +
            this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },

    setFontCss: function(){
        switch(this.fontstyle){
            case 'font1':
                this.fontcss = '!important;\n--font: "Zen Kaku Gothic Antique", sans-serif;}'
                break;
            case 'font2':
                this.fontcss = '!important;\n--font: "Hachi Maru Pop", cursive;}'
                break;
            case 'font3':
                this.fontcss = '!important;\n--font: "Stick", sans-serif;}'
                break;
            case 'font4':
                this.fontcss = '!important;\n--font: "DotGothic16", sans-serif;}'
                break;
            case 'font5':
                this.fontcss = '!important;\n--font: "Kaisei Decol", serif;}'
                break;
            case 'font6':
                this.fontcss = '!important;\n--font: "Kiwi Maru", serif;}'
                break;
            case 'font7':
                this.fontcss = '!important;\n--font: "M PLUS Rounded 1c", sans-serif;}'
                break;
            case 'font8':
                this.fontcss = '!important;\n--font: "RocknRoll One", sans-serif;}'
                break;
            case 'font9':
                this.fontcss = '!important;\n--font: "Yuji Mai", serif;}'
                break;
            case 'font10':
                this.fontcss = '!important;\n--font: "Yusei Magic", sans-serif;}'
                break;
            case 'font12':
                this.fontcss = '!important;\n--font:  "Sawarabi Mincho", serif;";}'
                break;
            case 'font13':
                this.fontcss = '!important;\n--font: "Shippori Mincho", serif;}'
                break;
            case 'font14':
                this.fontcss = '!important;\n--font: "Noto Serif SC", serif;}'
                break;
            case 'font15':
                this.fontcss = '!important;\n--font: "Josefin Sans", sans-serif;}'
                break;
        }
    },
    updateSvgBackground() {
      const svgcolor = this.colors3.hex.replace('#', '%23');
      const bgcolor = this.colors3.hex8;
      this.svgBackground = {
        "--bg-svg": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 256 256'%3E%3Cpath fill='${svgcolor}' d=' M 14.91 25.23 C 84.03 40.91 154.80 53.31 225.11 54.26 A 0.37 0.37 -89.9 0 1 225.48 54.63 L 225.67 242.23 A 0.31 0.31 -75.9 0 1 225.22 242.50 Q 210.97 235.22 197.62 226.40 Q 137.70 186.80 90.16 129.07 Q 49.24 79.39 14.56 25.73 Q 14.13 25.05 14.91 25.23 Z'%0A/%3E%3C/svg%3E")`,
        "--bg-color": `${bgcolor}`
      };
    }
  },
  computed: {
    resultCSS(){
        return this.importcss1 +
            this.colors.hex8 +
            this.importcss2 +
            this.colors2.hex8 +
            this.importcss3 +
            this.colors3.hex8 +
            this.importcss4 +
            this.svgBackground["--bg-svg"] +
            this.fontcss;
    },
    mainColor() {
      return {
        "--main-color": this.colors.hex8,
      };
    },
    subColor() {
      return {
        "--sub-color": this.colors2.hex8,
      };
    },
    fontStyle: function() {
      if (this.fontstyle === 'font1') {
        return 'font1';
      }
      else if (this.fontstyle === 'font2') {
        return 'font2';
      }
      else if (this.fontstyle === 'font3') {
        return 'font3';
      }
      else if (this.fontstyle === 'font4') {
        return 'font4';
      }
      else if (this.fontstyle === 'font5') {
        return 'font5';
      }
      else if (this.fontstyle === 'font6') {
        return 'font6';
      }
      else if (this.fontstyle === 'font7') {
        return 'font7';
      }
      else if (this.fontstyle === 'font8') {
        return 'font8';
      }
      else if (this.fontstyle === 'font9') {
        return 'font9';
      }
      else if (this.fontstyle === 'font10') {
        return 'font10';
      }
      else if (this.fontstyle === 'font12') {
        return 'font12';
      }
      else if (this.fontstyle === 'font13') {
        return 'font13';
      }
      else if (this.fontstyle === 'font14') {
        return 'font14';
      }
      else if (this.fontstyle === 'font15') {
        return 'font15';
      }
      else {
        return '';
      }
    },
  },
  created() {
    this.updateSvgBackground();
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Stick&display=swap');
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique&display=swap');

@import url('https://fonts.googleapis.com/css2?family=DotGothic16&family=Kaisei+Decol:wght@500&family=Kiwi+Maru:wght@500&family=M+PLUS+Rounded+1c:wght@500&family=RocknRoll+One&family=Sawarabi+Mincho&family=Shippori+Mincho:wght@500&family=Yuji+Mai&family=Yusei+Magic&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&family=Noto+Serif+SC&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}


.contents-block{

	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;

}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
  }
}
.set{
  padding: 8px 12px 24px 12px;

  border-radius: 10px;
  margin-left:12px;
}

/* コメントエリア */
.preview{
    padding: 2px 12px;
}
.line__left{
    background-color: #F2F0E9;
    padding:12px 0;
}
.line__left-text{
    margin: 6px auto !important;
    overflow: hidden !important;
    font-weight: bold !important;
    font-size: 16px !important;
    background-color: rgba(0, 0, 0, 0) !important;
    line-height: 1.8;
    letter-spacing: 0.1em;
    padding:12px 32px;
}

.text {
    display: inline-block !important;
    width: auto !important;
    color: var(--main-color);
  margin-left: 28px;
  padding: 10px 22px;
  position: relative;
  border-radius: 20px;
  box-shadow: 3px 3px 0 var(--sub-color);
  /* background-color: #ffffff; */
  background-color: var(--bg-color);
}

/* 吹き出し */
.text:after {
    content: '';
    position: absolute;
    left: -8px;
    top: 7px;
    width: 1em;
    height: 1em;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 256 256'%3E%3Cpath fill='%23ffffff' d=' M 14.91 25.23 C 84.03 40.91 154.80 53.31 225.11 54.26 A 0.37 0.37 -89.9 0 1 225.48 54.63 L 225.67 242.23 A 0.31 0.31 -75.9 0 1 225.22 242.50 Q 210.97 235.22 197.62 226.40 Q 137.70 186.80 90.16 129.07 Q 49.24 79.39 14.56 25.73 Q 14.13 25.05 14.91 25.23 Z'%0A/%3E%3C/svg%3E"); */
    background-image: var(--bg-svg);

}


.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
    font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.font1{
    font-family: 'Zen Kaku Gothic Antique', sans-serif;
}
.font2{
    font-family: 'Hachi Maru Pop', cursive;
}
.font3{
    font-family: 'Stick', sans-serif;
}
.font4{
    font-family: "DotGothic16", sans-serif;
}
.font5{
    font-family: "Kaisei Decol", serif;
}
.font6{
    font-family: "Kiwi Maru", serif;
}
.font7{
    font-family: "M PLUS Rounded 1c", sans-serif;
}
.font8{
    font-family: "RocknRoll One", sans-serif;
}
.font9{
    font-family: "Yuji Mai", serif;
}
.font10{
    font-family: "Yusei Magic", sans-serif;
}
.font12{
    font-family: 'Sawarabi Mincho', serif;
}
.font13{
    font-family: 'Shippori Mincho', serif;
}
.font14{
    font-family: 'Noto Serif SC', serif;
}
.font15{
    font-family: 'Josefin Sans', sans-serif;
}
.radio-main{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.color-select{
  display:flex;
}

.color-row{
  margin-right: 5px;
}
.m-form-text{
    width: 80%;
  height: 42px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.select{
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  width: 20%;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}

.line__left{
  display: block;
  white-space: nowrap;

}
</style>